import apiClient from './api';

// Unified accounts API: create a staff user or a customer, plus a public mock-OTP forgot-password flow.
const PUBLIC_BASE = process.env.REACT_APP_API_URL || '/api';

async function publicPost(path, body) {
  const res = await fetch(`${PUBLIC_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body || {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.error || 'Request failed. Please try again.');
  }
  return data;
}

export const accountsService = {
  // Unified list: one endpoint pages over either staff or customers, returning the same envelope for both.
  list: async ({ type = 'staff', search = '', page = 1, pageSize = 50, order = '' } = {}) => {
    const params = new URLSearchParams();
    params.set('type', type);
    if (search) params.set('search', search);
    if (order) params.set('order', order); // e.g. 'name', '-last_activity' (customers)
    params.set('page', page);
    params.set('page_size', pageSize);
    const { data } = await apiClient.get(`/users/accounts/list/?${params.toString()}`);
    return data.data; // { results, total, page, page_size }
  },

  // payload: { type: 'user'|'customer', ...fields }
  create: async (payload) => {
    const { data } = await apiClient.post('/users/accounts/create/', payload);
    return data; // { success, type, data:{id}, message }
  },

  // Forgot-password (mock OTP by phone). type: 'user' | 'customer'.
  requestOtp: (type, phone) =>
    publicPost('/users/accounts/forgot-password/request-otp/', { type, phone }),

  resetPassword: (type, phone, code, newPassword) =>
    publicPost('/users/accounts/forgot-password/reset/', {
      type, phone, code, new_password: newPassword,
    }),
};

export default accountsService;
